import type { ReferenceRecord } from "../use-reference-data";

export const INQUIRY_DISCOUNT_TYPES = {
  DOLLAR: "DOL",
  PERCENT: "PER"
} as const;

const DOLLAR_DISCOUNT_TYPE_VALUES = new Set(["$", "DOLLAR", INQUIRY_DISCOUNT_TYPES.DOLLAR]);
const PERCENT_DISCOUNT_TYPE_VALUES = new Set(["%", "PERCENT", INQUIRY_DISCOUNT_TYPES.PERCENT]);

export type InquiryDiscountTypeSymbol = "" | "$" | "%";
export type InquiryDiscountTypeCode = (typeof INQUIRY_DISCOUNT_TYPES)[keyof typeof INQUIRY_DISCOUNT_TYPES];

const normalizeDiscountType = (discountType?: string | null): string => {
  return discountType?.trim().toUpperCase() ?? "";
};

export const toDiscountTypeSymbol = (discountType?: string | null): InquiryDiscountTypeSymbol => {
  const normalizedDiscountType = normalizeDiscountType(discountType);

  if (DOLLAR_DISCOUNT_TYPE_VALUES.has(normalizedDiscountType)) {
    return "$";
  }

  if (PERCENT_DISCOUNT_TYPE_VALUES.has(normalizedDiscountType)) {
    return "%";
  }

  return "";
};

export const toDiscountTypeCode = (discountType?: string | null): InquiryDiscountTypeCode | null => {
  if (discountType === "$") {
    return INQUIRY_DISCOUNT_TYPES.DOLLAR;
  }

  if (discountType === "%") {
    return INQUIRY_DISCOUNT_TYPES.PERCENT;
  }

  return null;
};

export const referenceRecordToDiscountTypeSymbol = (
  discountType?: Pick<ReferenceRecord, "value" | "name"> | null
): InquiryDiscountTypeSymbol => {
  return toDiscountTypeSymbol(discountType?.value?.toString()) || toDiscountTypeSymbol(discountType?.name);
};
